import { createRouter, createWebHistory } from 'vue-router'
import { constantRouterMap } from '@/config/router.config'

const routes = constantRouterMap

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
